import React, { Component } from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { DEFAULT_BREAKPOINTS } from 'react-bootstrap/esm/ThemeProvider';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import LeftMenu from '../components/LeftMenu';
import loginlogo from '../login-logo.png';
import RouterLibrary from '../RouterLibrary';
import configData from '../configData.json';
import { useRef } from 'react';
import { Spinner, Button } from 'react-bootstrap';
import { getMenuItems, setMenuItems } from '../components/menucomponents/menuStorage'
import OtpInput from 'react-otp-input';
import { useModal } from '../context/WarningModalContext';

const AuthenticationOtp = () => {
    const [userDetails, setUserDetails] = useState({});
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedPassword, setSelectedPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [otp, setOtp] = useState('');
    const { showModal } = useModal();

    let userDetailsRef = useRef({});
    userDetailsRef.current = userDetails;

    const navigate = useNavigate();
    const location = useLocation();

    // Access loginData from location state
    const loginData = location.state ? location.state.loginData : null;

    // Function to mask email address
    const maskEmail = (email) => {
        const [username, domain] = email.split('@');
        const maskedUsername = username.length > 4 ? username.slice(0, 2) + '*'.repeat(username.length - 4) + username.slice(-2) : username;
        return `${maskedUsername}@${domain}`;
    };

    // Code for Select UserName on Change
    const selectUserName = (e) => {
        let value = e.target.value;
        var data = value;
        setSelectedUser(data)

    };

    // Code for Select UserName on Change
    const selectPassword = (e) => {
        let value = e.target.value;
        var data = value;
        setSelectedPassword(data)

    };

    const handleResendCode = async (e) => {
        debugger;
        // setLoading(true);
        e.preventDefault();
        const link = e.target;
        const validateOtpButton = document.getElementById("validateOtpId");
        validateOtpButton.disabled = true;
        let email = loginData.email;
        const URL = `${configData.BASE_APP_URL}Login/requesttwostepauthenticationtoken?email=${email}`;
        try {
            const resp = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    Authorization: loginData.token,
                },
            });

            debugger;
            if (resp.ok) {
                link.innerText = ''; // or link.textContent = '';
                validateOtpButton.disabled = false;
            } else if (resp.status === 400) {
                const errorData = await resp.json();
                document.getElementById("error").innerHTML = errorData.message;
            } else {
                const errorData = await resp.json();
                document.getElementById("error").innerHTML = errorData.message;
            }
        } catch (error) {
            // Handle errors here
            console.error('There was an error!', error);
        } finally {
            // setLoading(false);
        }
    };

    // Updated onChange handler for OtpInput
    const handleOtpChange = (otpValue) => {
        setOtp(otpValue);
        // Get the button element
        const validateOtpButton = document.getElementById("validateOtpId");

        // Disable the button if otp.length is not equal to 6, otherwise enable it
        if (otpValue.length !== 6) {
            validateOtpButton.disabled = true;
        } else {
            validateOtpButton.disabled = false;
        }
        document.getElementById("error").innerHTML = "";
    };


    const validateOtp = async () => {
        debugger;
        setLoading(true);
        let email = loginData.email;
        const URL = `${configData.BASE_APP_URL}Login/LoginTwoStepAuthentication?email=${email}&token=${otp}`;
        try {
            const resp = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    Authorization: loginData.token,
                },
            });

            if (resp.ok) {
                fetchMenuData();
            } else if (resp.status === 400) {
                const errorData = await resp.json();
                document.getElementById("error").innerHTML = errorData.message;
            } else {
                const errorData = await resp.json();
                document.getElementById("error").innerHTML = errorData.message;
            }
        } catch (error) {
            // Handle errors here
            console.error('There was an error!', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchMenuData = async () => {
        debugger;
        let email = loginData.email;
        const menuUrl = `${configData.BASE_APP_URL}Login/GetMenus/${email}`;

        try {
            const resp = await fetch(menuUrl, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    Authorization: loginData.token,
                },
            });
            const parsedResp = await resp.json();

            const menuItems = parsedResp.map((item) => ({
                name: item.label,
                isdisabled: false,
                isActive: item.id === 10,
                href: `../${item.formName}`,
                id: item.id,
                menuIcon: item.menuIcon,
                formName: item.formName
            }));

            // Save menuItems to sessionStorage using the setMenuItems function
            setMenuItems(menuItems);
            sessionStorage.setItem('my-emailid', loginData.email);
            sessionStorage.setItem('my-username', loginData.userName);
            sessionStorage.setItem('my-fullname', loginData.fullName);
            sessionStorage.setItem('my-token', loginData.token);
            navigate(`/${menuItems[0].formName}`);
            showModal();
        } catch (error) {
            // Handle any errors that occur during the fetch or parsing process
            console.error('An error occurred:', error);
        }
    };

    // Model for User Credentials
    const userCredentials = {
        userName: selectedUser,
        userPassword: selectedPassword
    };

   
    const Loader = () => {
        return (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        )
    }

    return (
        <div className='login-container shadow-sm bg-body rounded border d-flex'>
            <div className='login-logo d-flex align-items-center justify-content-center p-3 rounded-start'>
                {<img src={loginlogo}></img>}
                {/* 
                <div className='text-center mt-4 text-white'>

                    Doesn't have an account yet?


                </div> */}
                {/* 
                <div className='text-center '>

                    <u className='text-white'> <a className='text-white' href='#'>Sign Up Now!</a></u>


                </div> */}

            </div>
            <div className='login-field d-flex align-items-center p-3'>
                <div>
                    <h5>Check Your Mail</h5>
                    <p className='mb-3'>Enter 6 digit authentication code sent to <br /> ({loginData ? maskEmail(loginData.email) : ''})</p>

                    <div className="d-flex container">
                        <OtpInput
                            containerStyle={'otpinput'}
                            value={otp}
                            onChange={handleOtpChange}
                            numInputs={6}
                            placeholder={''}
                            isInputNum={true}
                            shouldAutoFocus={true}
                            // renderSeparator={<span>-</span>}
                            renderInput={(props) => <input {...props} />}
                        />
                        {/* <div id="inputs" className="inputs">
                            <input id='otpinput1' className="otpinput" type="text" inputmode="numeric" maxlength="1" />
                            <input id='otpinput2' className="otpinput" type="text" inputmode="numeric" maxlength="1" />
                            <input id='otpinput3' className="otpinput" type="text" inputmode="numeric" maxlength="1" />
                            <input id='otpinput4' className="otpinput" type="text" inputmode="numeric" maxlength="1" />
                            <input id='otpinput5' className="otpinput" type="text" inputmode="numeric" maxlength="1" />
                            <input id='otpinput6' className="otpinput" type="text" inputmode="numeric" maxlength="1" />
                        </div> */}
                    </div>


                    <div id="error" className="text-danger" style={{ textAlign: 'center' }}></div>
                    <div className='d-grid gap-2 mt-3'>

                        <button id="validateOtpId"
                            className="btn btn-login btn-block"
                            type="button"
                            onClick={validateOtp}
                            disabled={loading || otp.length !== 6}
                        >   
                            {loading && <Loader />} {'  '}
                            Verify Authentication Code
                        </button>

                    </div>

                    <div className='text-center mt-1'>

                        <a href='#' onClick={handleResendCode}>Not Received Code? Resend Code</a>


                    </div>

                </div>
            </div>
        </div>

    )
}

export default AuthenticationOtp;
